var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "FormFieldsContainer",
        { attrs: { titulo: _vm.titulo } },
        [
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.model_serienumero_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: _vm.accion_modal == "EDITAR"
                },
                on: {
                  change: function($event) {
                    return _vm.buscar_serie_numero()
                  }
                },
                model: {
                  value: _vm.formFields.model_serienumero_new.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.model_serienumero_new, "value", $$v)
                  },
                  expression: "formFields.model_serienumero_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _vm.accion_modal != "EDITAR"
                ? _c("v-autocomplete", {
                    attrs: {
                      "item-text": "tipoeqname",
                      items: _vm.lista_tipoeqname,
                      "item-value": "tipoeqid",
                      label: _vm.formFields.model_tipoeqname_new.label,
                      "prepend-icon": "home_repair_service",
                      disabled: _vm.detalle
                    },
                    on: {
                      input: function($event) {
                        return _vm.get_equipo_activa()
                      }
                    },
                    model: {
                      value: _vm.formFields.model_tipoeqname_new.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formFields.model_tipoeqname_new,
                          "value",
                          $$v
                        )
                      },
                      expression: "formFields.model_tipoeqname_new.value"
                    }
                  })
                : _vm._e(),
              _vm.accion_modal == "EDITAR"
                ? _c("v-text-field", {
                    attrs: {
                      "item-text": "tipoeqname",
                      items: _vm.lista_tipoeqname,
                      "item-value": "tipoeqid",
                      label: _vm.formFields.model_tipoeqname_new.label,
                      "prepend-icon": "home_repair_service",
                      disabled: _vm.detalle
                    },
                    on: {
                      input: function($event) {
                        return _vm.get_equipo_activa()
                      }
                    },
                    model: {
                      value: _vm.formFields.model_tipoeqname_new.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formFields.model_tipoeqname_new,
                          "value",
                          $$v
                        )
                      },
                      expression: "formFields.model_tipoeqname_new.value"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serie_activa_numero_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serie_activa_numero_new.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.formFields.serie_activa_numero_new,
                      "value",
                      $$v
                    )
                  },
                  expression: "formFields.serie_activa_numero_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serie_activa_modalidad_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serie_activa_modalidad_new.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.formFields.serie_activa_modalidad_new,
                      "value",
                      $$v
                    )
                  },
                  expression: "formFields.serie_activa_modalidad_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serie_activa_plataforma_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serie_activa_plataforma_new.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.formFields.serie_activa_plataforma_new,
                      "value",
                      $$v
                    )
                  },
                  expression: "formFields.serie_activa_plataforma_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-checkbox", {
                attrs: {
                  label: _vm.formFields.serieactivaplata_ingresada_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serieactivaplata_ingresada_new.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.formFields.serieactivaplata_ingresada_new,
                      "value",
                      $$v
                    )
                  },
                  expression: "formFields.serieactivaplata_ingresada_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serieactivaplata_fecha_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serieactivaplata_fecha_new.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.formFields.serieactivaplata_fecha_new,
                      "value",
                      $$v
                    )
                  },
                  expression: "formFields.serieactivaplata_fecha_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serieactivaid_dispositivo_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serieactivaid_dispositivo_new.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.formFields.serieactivaid_dispositivo_new,
                      "value",
                      $$v
                    )
                  },
                  expression: "formFields.serieactivaid_dispositivo_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serieactivaepc_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serieactivaepc_new.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.serieactivaepc_new, "value", $$v)
                  },
                  expression: "formFields.serieactivaepc_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.sim_serie_numero_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.sim_serie_numero_new.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.sim_serie_numero_new, "value", $$v)
                  },
                  expression: "formFields.sim_serie_numero_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.sim_estado_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.sim_estado_new.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.sim_estado_new, "value", $$v)
                  },
                  expression: "formFields.sim_estado_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.patente_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.patente_new.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.patente_new, "value", $$v)
                  },
                  expression: "formFields.patente_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.clienterut_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.clienterut_new.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.clienterut_new, "value", $$v)
                  },
                  expression: "formFields.clienterut_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.nombre_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.nombre_new.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.nombre_new, "value", $$v)
                  },
                  expression: "formFields.nombre_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.nombre_flota.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.nombre_flota.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.nombre_flota, "value", $$v)
                  },
                  expression: "formFields.nombre_flota.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serieactivafecha_baja_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serieactivafecha_baja_new.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.formFields.serieactivafecha_baja_new,
                      "value",
                      $$v
                    )
                  },
                  expression: "formFields.serieactivafecha_baja_new.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.serieactivaobs_new.label,
                  required: "",
                  "prepend-icon": "integration_instructions",
                  color: "primary",
                  disabled: ""
                },
                model: {
                  value: _vm.formFields.serieactivaobs_new.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.serieactivaobs_new, "value", $$v)
                  },
                  expression: "formFields.serieactivaobs_new.value"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }